var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M98.867 84.063 64.701 49.766l34.244-33.855a3.613 3.613 0 0 0 0-5.104l-9.739-9.791a3.584 3.584 0 0 0-2.552-1.042c-.964 0-1.875.391-2.552 1.042l-34.089 33.75L15.872 1.042A3.583 3.583 0 0 0 13.32 0c-.963 0-1.875.391-2.552 1.042l-9.713 9.791a3.615 3.615 0 0 0 0 5.105l34.244 33.854-34.14 34.271a3.607 3.607 0 0 0-1.068 2.552c0 .963.365 1.875 1.068 2.552l9.739 9.791a3.593 3.593 0 0 0 2.553 1.068c.911 0 1.848-.338 2.552-1.068l34.01-34.166 34.036 34.14A3.593 3.593 0 0 0 86.602 100c.911 0 1.849-.339 2.552-1.068l9.739-9.791a3.609 3.609 0 0 0 1.068-2.552 3.734 3.734 0 0 0-1.094-2.526Z"}));
}

Close.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = Close;

Close.default = Close;
